export const LINKS = {
	SIGNUP: '/signup',
	LOGIN: '/login',
	APP: '/',
	DASHBOARD: '/dashboard',
	ONBOARDING: '/onboarding',
	RENEW_MEMBER: '/renew_member/:portal_id/:contact_id',
	LINKED_MEMBERS: '/link_members/:primary_member/:portal_id',
	SYSTEM_ERROR: '/error',
	ALL: '*'
};
